<template>
	<v-dialog v-model="dialog" max-width="400px">
		<v-card>
			<v-app-bar dense dark flat color="primary">
				<v-app-bar-title class="color-white">物流データの更新 | {{ title }}</v-app-bar-title>
				<v-spacer />
				<v-btn icon dark @click="dialog = false" color="white">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-app-bar>
			<h3 class="pa-2">クリック対象：{{ requirement.order_individual_info.product_number }}</h3>
			<h3 class="pa-2">現在のデータ：{{ nowData }}</h3>
			<v-card-text class="pa-2">
				<v-form ref="form" lazy-validation>
					<v-select
						v-model="selectedType"
						:items="targetType"
						item-text="name"
						item-value="value"
						label="対象"
						class="mt-2 mx-1"
						outlined
						dense
					>
					</v-select>
					<v-row class="d-flex flex-wrap justify-center" no-gutters>
						<v-text-field
							v-if="editTarget == 'shipping_date'"
							type="date"
							v-model="sendValue"
							class="mt-2 mx-1"
							label="出荷日"
							outlined
							dense
						/>
						<v-text-field
							v-if="editTarget == 'deadline'"
							type="date"
							v-model="sendValue"
							class="mt-2 mx-1"
							label="納期"
							outlined
							dense
						/>
						<v-text-field
							v-if="editTarget == 'prefecture'"
							type="text"
							v-model="sendValue"
							class="mt-2 mx-1"
							label="都道府県"
							outlined
							dense
						/>
						<v-text-field
							v-if="editTarget == 'city'"
							type="text"
							v-model="sendValue"
							class="mt-2 mx-1"
							label="市郡町村"
							outlined
							dense
						/>
						<v-textarea
							v-if="editTarget == 'remarks'"
							v-model="sendValue"
							class="mt-2 mx-1"
							label="特記事項"
							outlined
							dense
						/>
						<v-textarea
							v-if="editTarget == 't_method'"
							v-model="sendValue"
							class="mt-2 mx-1"
							label="運送方法"
							outlined
							dense
						/>
						<v-textarea
							v-if="editTarget == 'biko'"
							v-model="sendValue"
							class="mt-2 mx-1"
							label="特記事項"
							outlined
							dense
						/>
						<v-autocomplete
							v-if="editTarget == 'car_model'"
							v-model="sendValue"
							class="mt-2 mx-1"
							label="車種"
							:items="carModels"
							required
							outlined
							dense
							hide-details="auto"
						/>
						<v-text-field
							v-if="editTarget == 'number_of_vehicles'"
							type="number"
							v-model="sendValue"
							class="mt-2 mx-1"
							label="台数"
							outlined
							dense
						/>
						<v-text-field
							v-if="editTarget == 'packing_style'"
							type="text"
							v-model="sendValue"
							class="mt-2 mx-1"
							label="荷姿"
							outlined
							dense
						/>
						<v-text-field
							v-if="editTarget == 'packing_spec'"
							type="text"
							v-model="sendValue"
							class="mt-2 mx-1"
							label="梱包指定"
							outlined
							dense
						/>
						<v-select
							v-if="editTarget == 'shipping_guide'"
							v-model="sendValue"
							:items="['-', '要']"
							label="送品案内"
							class="mt-2 mx-1"
							dense
							outlined
						/>
						<v-select
							v-if="editTarget == 'return_envelope'"
							v-model="sendValue"
							:items="['-', '要']"
							label="返信封筒"
							class="mt-2 mx-1"
							dense
							outlined
						/>
						<v-select
							v-if="editTarget == 'drawing'"
							v-model="sendValue"
							:items="['-', '要']"
							label="図面"
							class="mt-2 mx-1"
							dense
							outlined
						/>
						<v-select
							v-if="editTarget == 'map'"
							v-model="sendValue"
							:items="['-', '要']"
							label="地図"
							class="mt-2 mx-1"
							dense
							outlined
						/>
						<v-select
							v-if="editTarget == 'ordered_accepted'"
							v-model="sendValue"
							:items="['-', '完']"
							label="発注＆受入したか"
							class="mt-2 mx-1"
							dense
							outlined
						/>
						<v-text-field
							v-if="editTarget == 'designated_form'"
							type="text"
							v-model="sendValue"
							class="mt-2 mx-1"
							label="指定伝票"
							outlined
							dense
						/>
						<v-text-field
							v-if="editTarget == 'report_of_results'"
							type="text"
							v-model="sendValue"
							class="mt-2 mx-1"
							label="成績書"
							outlined
							dense
						/>
						<v-text-field
							v-if="editTarget == 'specimen_list'"
							type="text"
							v-model="sendValue"
							class="mt-2 mx-1"
							label="現品表"
							outlined
							dense
						/>
						<v-text-field
							v-if="editTarget == 'shipping_permittion'"
							type="text"
							v-model="sendValue"
							class="mt-2 mx-1"
							label="出荷許可"
							outlined
							dense
						/>
						<v-text-field
							v-if="editTarget == 'freight_costs'"
							type="number"
							v-model="sendValue"
							class="mt-2 mx-1"
							label="運送費"
							outlined
							dense
						/>
						<v-text-field
							v-if="editTarget == 'fare'"
							type="number"
							v-model="sendValue"
							class="mt-2 mx-1"
							label="運賃"
							outlined
							dense
						/>
						<v-text-field
							v-if="editTarget == 'relay_fee'"
							type="number"
							v-model="sendValue"
							class="mt-2 mx-1"
							label="中継料"
							outlined
							dense
						/>
						<v-text-field
							v-if="editTarget == 'winter_surcharge'"
							type="number"
							v-model="sendValue"
							class="mt-2 mx-1"
							label="冬季割増料"
							outlined
							dense
						/>
						<v-text-field
							v-if="editTarget == 'insurance_premium'"
							type="number"
							v-model="sendValue"
							class="mt-2 mx-1"
							label="保険料"
							outlined
							dense
						/>
						<v-text-field
							v-if="editTarget == 'charter_fee'"
							type="number"
							v-model="sendValue"
							class="mt-2 mx-1"
							label="チャーター料"
							outlined
							dense
						/>
						<v-text-field
							v-if="editTarget == 'receipt'"
							type="date"
							v-model="sendValue"
							class="mt-2 mx-1"
							label="受領書"
							outlined
							dense
						/>
						<v-text-field
							v-if="editTarget == 'number_of_paking'"
							type="number"
							v-model="sendValue"
							class="mt-2 mx-1"
							label="個数"
							outlined
							dense
						/>
						<v-text-field
							v-if="editTarget == 'kg'"
							type="number"
							v-model="sendValue"
							class="mt-2 mx-1"
							label="重量(kg)"
							outlined
							dense
						/>
						<v-textarea
							v-if="selectedAnswerValueId"
							v-model="reason"
							class="mt-2 mx-1"
							label="変更理由"
							outlined
							dense
						/>
					</v-row>
					<v-row class="d-flex flex-wrap justify-center" no-gutters>
						<v-btn class="ma-2 pa-2 mt-4" color="primary" @click="choiceMethod()">編集を保存</v-btn>
						<v-btn
							v-if="selectedAnswerValueId"
							class="ma-2 pa-2 mt-4"
							color="primary"
							@click="openHistory()"
							>履歴確認</v-btn
						>
					</v-row>
				</v-form>
			</v-card-text>
			<v-card-actions>
				<v-row no-gutters> </v-row>
			</v-card-actions>
		</v-card>
		<AnswerValueHistory ref="history" />
	</v-dialog>
</template>

<script>
import moment from "moment"
import axios from "axios"
import authenticate from "../../../helper/authenticate"
import errorHandling from "../../../helper/errorHandling"
import common from "../../../helper/common"
import rules from "../../../helper/rules"
import FunctionTitle from "../../shared/FunctionTitle.vue"
import CommonFlame from "../../shared/CommonFlame.vue"
import AnswerValueHistory from "./AnswerValueHistory.vue"
// editTargetをVueとRailsで共有する必要あり
export default {
	components: {
		AnswerValueHistory,
	},
	props: {},
	data() {
		return {
			dialog: false,
			targetType: [
				{ name: "選択した子番号のみ", value: "individual" },
				{ name: "同製造番号全て", value: "product" },
				{ name: "同注文全て", value: "order" },
			],
			nowData: "",
			selectedType: "",
			requirement: {
				id: "",
				order_individual_info: { id: "", product_number: "", delivery_info: { id: "" } },
			},
			carModels: [],
			editTarget: "",
			sendValue: null,
			reason: "",
			deliveryInfoTargets: ["shipping_date", "prefecture", "city", "deadline"],
			AnswerValueTargets: [
				"remarks",
				"t_method",
				"car_model",
				"number_of_vehicles",
				"packing_style",
				"number_of_paking",
				"kg",
				"biko",
				"packing_spec",
				"shipping_guide",
				"designated_form",
				"report_of_results",
				"specimen_list",
				"return_envelope",
				"drawing",
				"map",
				"shipping_permittion",
				"freight_costs",
				"receipt",
				"fare",
				"relay_fee",
				"winter_surcharge",
				"insurance_premium",
				"charter_fee",
				"ordered_accepted",
			],
			selectedAnswerValueId: "",
			title: "",
		}
	},
	methods: {
		openDialog(req, target, nowData, valueId, jap) {
			this.dialog = true
			this.nowData = nowData
			this.requirement = req
			this.editTarget = target
			this.selectedAnswerValueId = valueId
			this.title = jap
			console.log(target)
			if (this.editTarget == "car_model") {
				this.fetchCarModels()
			}
		},
		fetchCarModels() {
			const headers = authenticate.setHeader()
			axios
				.get("/erp/v1/car_models.json", { headers })
				.then((res) => {
					this.carModels = res.data.car_models
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		choiceMethod() {
			if (this.selectedType) {
				if (this.deliveryInfoTargets.includes(this.editTarget)) {
					this.updateDeliveryInfo()
				} else if (this.AnswerValueTargets.includes(this.editTarget)) {
					if (this.nowData != null) {
						this.updateAnswerValue()
					} else {
						this.createAnswerValue()
					}
				}
			} else {
				this.$store.dispatch("setFlash", {
					text: "対象を選んでください",
					type: "alert",
				})
			}
		},
		openHistory() {
			this.$refs.history.openDialog(this.selectedAnswerValueId)
		},
		updateDeliveryInfo() {
			const headers = authenticate.setHeader()
			var formData = new FormData()
			formData.set("requirement_id", this.requirement.id)
			formData.set("selected_type", this.selectedType)
			formData.set("edit_target", this.editTarget)
			formData.set("send_value", this.sendValue)
			formData.set("delivery_info_id", this.requirement.order_individual_info.delivery_info.id)
			axios
				.put(
					"/erp/v1/logistics/delivery_infos/" +
						this.requirement.order_individual_info.delivery_info.id +
						".json",
					formData,
					{ headers }
				)
				.then((res) => {
					this.sendValue = null
					this.selectedType = ""
					this.editTarget = ""
					this.reason = ""
					this.$emit("reloadIndex")
					this.dialog = false
					this.$store.dispatch("setFlash", {
						text: "更新しました",
						type: "notice",
					})
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		createAnswerValue() {
			const headers = authenticate.setHeader()
			var formData = new FormData()
			formData.set("requirement_id", this.requirement.id)
			formData.set("selected_type", this.selectedType)
			formData.set("edit_target", this.editTarget)
			formData.set("send_value", this.sendValue)
			formData.set("order_individual_info_id", this.requirement.order_individual_info.id)
			axios
				.post("/erp/v1/logistics/answer_values.json", formData, { headers })
				.then((res) => {
					this.sendValue = null
					this.selectedType = ""
					this.editTarget = ""
					this.reason = ""
					this.$emit("reloadIndex")
					this.dialog = false
					this.$store.dispatch("setFlash", {
						text: "更新しました",
						type: "notice",
					})
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		updateAnswerValue() {
			const headers = authenticate.setHeader()
			var formData = new FormData()
			formData.set("requirement_id", this.requirement.id)
			formData.set("selected_type", this.selectedType)
			formData.set("edit_target", this.editTarget)
			formData.set("send_value", this.sendValue)
			formData.set("reason", this.reason)
			formData.set("order_individual_info_id", this.requirement.order_individual_info.id)
			formData.set("answer_value_id", this.selectedAnswerValueId)
			axios
				.post("/erp/v1/logistics/answer_values.json", formData, { headers })
				.then((res) => {
					this.$emit("reloadIndex")
					this.dialog = false
					this.$store.dispatch("setFlash", {
						text: "更新しました",
						type: "notice",
					})
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
	},
	computed: {},
}
</script>

<style lang="scss" scoped>
.v-input--selection-controls {
	margin-top: 0;
}
</style>
